import { createMedia as artsyCreateMedia } from "@artsy/fresnel";
import { useContextSelector } from "use-context-selector";
import { createSizeProvider } from "./createSizeProvider";
export function createMedia(breakpoints, options = {}) {
  const {
    createMediaStyle,
    Media,
    MediaContextProvider
  } = artsyCreateMedia({
    breakpoints
  });
  const {
    SizeProvider,
    SizeContext
  } = createSizeProvider(options);
  function useSizeContextSelector(selector) {
    return useContextSelector(SizeContext, selector);
  }
  return {
    createMediaStyle,
    breakpoints,
    SizeProvider,
    useSizeContextSelector,
    Media,
    MediaContextProvider
  };
}